/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ParsingMessage,
    ParsingMessageFromJSON,
    ParsingMessageFromJSONTyped,
    ParsingMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface ParsedFileDetails
 */
export interface ParsedFileDetails {
    /**
     * Name of the parsed file including extension
     * @type {string}
     * @memberof ParsedFileDetails
     */
    fileName: string;
    /**
     * Messages and errors from the parsing process
     * @type {Array<ParsingMessage>}
     * @memberof ParsedFileDetails
     */
    parsingMessages: Array<ParsingMessage>;
}

export function ParsedFileDetailsFromJSON(json: any): ParsedFileDetails {
    return ParsedFileDetailsFromJSONTyped(json, false);
}

export function ParsedFileDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParsedFileDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileName': json['file_name'],
        'parsingMessages': ((json['parsing_messages'] as Array<any>).map(ParsingMessageFromJSON)),
    };
}

export function ParsedFileDetailsToJSON(value?: ParsedFileDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file_name': value.fileName,
        'parsing_messages': ((value.parsingMessages as Array<any>).map(ParsingMessageToJSON)),
    };
}


